
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { VuetifyMixin } from '../../mixins/VuetifyMixin';
import { OrganizationModel } from '@/models/organization/OrganizationModel';

@Component
export default class OrgCard extends Mixins(VuetifyMixin){
	@Prop({ type: Boolean, default: false }) loading: boolean;
	@Prop({ required: true }) organization: OrganizationModel;
}
